module.exports = __webpack_public_path__ + "img/cart-logo.png";